import { DomainExtension, DomainSuggestion } from './types';

function sanitize(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove accents
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

export function generateDomains(
  companyName: string,
  extensions: DomainExtension[],
  acronym?: string,
): DomainSuggestion[] {
  const base = sanitize(companyName);
  const acr = acronym ? sanitize(acronym) : '';
  const suggestions = new Set<string>();

  // Base name with selected extensions
  for (const ext of extensions) {
    suggestions.add(base + ext);
  }

  // If acronym exists, add acronym-based suggestions with selected extensions
  if (acr && acr.length >= 2) {
    for (const ext of extensions) {
      suggestions.add(acr + ext);
    }
  }

  // Variants without hyphens
  const noHyphen = base.replace(/-/g, '');
  if (noHyphen !== base) {
    for (const ext of extensions) {
      suggestions.add(noHyphen + ext);
    }
  }

  // Short variant (first word only)
  const firstWord = base.split('-')[0];
  if (firstWord !== base && firstWord.length >= 3) {
    for (const ext of extensions) {
      suggestions.add(firstWord + ext);
    }
  }

  // Take only 10
  const result: DomainSuggestion[] = Array.from(suggestions)
    .slice(0, 10)
    .map((domain) => ({ domain, available: null }));

  return result;
}